<template>
  <div>
    <div class="row">
      <div class="col">
        <h5>Programme selection</h5>
        <div>
          Please select for which Speciality Days Programme you are submitting your abstract.
          <br>
          Please note, you may submit abstracts in multiple submissions
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="alert alert-info mb-1">
          <div class="row">
            <div class="col-1 d-flex">
              <icon :icon="['fad', 'exclamation']" class="my-auto fa-2x"/>
            </div>
            <div class="col">
              Please note that you <span class="text-danger">may not change the option later</span> in the
              abstract submission process.<br>
              If you would like to use a different option, you will have to create a new
              abstract.<br>
              <span class="text-danger">Please consult the guidelines, before completing your abstract submission.</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">AFAS - Instability in Athlete’s Foot and Ankle, Beyond the Lateral Ligaments</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(1)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">EKA - Robotics, AI and Digital Tools in Knee Surgery</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(2)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">ESA - Innovations in Cuff Repair from Mechanical to Biological Augmentation</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(3)">Select</button>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="card h-100">
          <div class="card-body">
            <h5 class="card-title text-success" style="text-align: center;">ESMA - EHPA  - Groin Pain in Athletes</h5>
          </div>
          <div class="card-footer bg-transparent border-0 d-flex">
            <button class="btn btn-success mx-auto" v-on:click="newAbstract(4)">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'

export default {
  name: "AbstractType",
  data() {
    return {
      submitted: false,
    };
  },
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'UPDATE_REFERENCE'
    ]),
    newAbstract(type) {

      let template = {
        "user_id": this.user.id,
        "type_id": type,
        "setting_submission_id": 1,
        "reference_number": this.getSettings(1).reference_number,
        "content": {},
        "status_id": 1
      };

      this.CREATE_ABSTRACT(template).then((response) => {
        this.$noty.success(this.wording[0].notify.save_success);
        this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(1).id)
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      });
    }
  },
  computed: {
    ...mapState([
      'wording', 'user'
    ]),
    ...mapGetters([
      'getSettings', 'getFirstCurrentPage'
    ]),
  },
}
</script>

<style scoped>

</style>